/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
/* eslint-disable react-native/no-color-literals */
import React from 'react';
import { View, ScrollView, TouchableOpacity, StyleSheet } from 'react-native';
import { useDispatch } from 'react-redux';
import { isWeb } from '@global/screens';
import PropTypes from 'prop-types';
import Colors from '@global/colors';
import SociollaText from '@components/sociolla/SociollaText';
import Image from '@components/global/Image';
import { showImage } from '@/store/global';

const GwpTrackerDisplay = ({ gwpTrackers = [] }) => {
  const dispatch = useDispatch();

  const openImage = (url) => {
    dispatch(
      showImage({
        isModal: true,
        disableCDN: true,
        isMultiple: true,
        allImage: [url],
        url,
        noArrow: true,
      }),
    );
  };

  const renderProgress = (stock = 0, out = 0) => {
    const percent = stock ? (out / stock) * 100 : 0;
    return (
      <View style={{ marginBottom: 16 }}>
        <View style={styles.progressBarBackground}>
          <View
            style={[
              styles.progressBarFill,
              { width: `${Math.min(percent, 100)}%` },
            ]}
          />
        </View>
      </View>
    );
  };

  return (
    <ScrollView
      testID="todo-gwp-tracker-display-container"
      style={styles.container}
      showsVerticalScrollIndicator={false}>
      {!gwpTrackers.length ? (
        <View style={styles.emptyState}>
          <SociollaText type="medium" style={styles.emptyTitle}>
            No GWP Data Yet
          </SociollaText>
          <SociollaText style={styles.emptyDesc}>
            GWP tracker submissions will appear here.
          </SociollaText>
        </View>
      ) : (
        gwpTrackers.map((tracker, idx) => {
          const stock = tracker?.gwp_stock || 0;
          const out = tracker?.gwp_out || 0;

          return (
            <View key={idx} style={styles.card}>
              <View style={styles.topRow}>
                <View style={{ flex: 1 }}>
                  <SociollaText type="bold" style={styles.campaign}>
                    {tracker?.campaign || '-'}
                  </SociollaText>
                  <SociollaText style={styles.detail}>
                    {tracker?.campaign_detail || '-'}
                  </SociollaText>
                </View>

                <View style={styles.brandBadge}>
                  <SociollaText type="medium" style={styles.brandText}>
                    {tracker?.brand?.name || '-'}
                  </SociollaText>
                </View>
              </View>

              <View style={styles.productRow}>
                <TouchableOpacity
                  onPress={() => openImage(tracker.product?.image)}>
                  <Image
                    style={styles.productImage}
                    width={80}
                    height={80}
                    source={tracker.product?.image || ''}
                    resizeMode="contain"
                  />
                </TouchableOpacity>

                <View style={{ flex: 1 }}>
                  <SociollaText type="medium" style={styles.productName}>
                    {tracker.product?.name || '-'}
                  </SociollaText>
                  <SociollaText style={styles.productSku}>
                    {tracker.product?.reference || '-'}
                  </SociollaText>
                </View>
              </View>

              {/* Progress */}
              {renderProgress(stock, out)}

              <View style={styles.stockRow}>
                <SociollaText style={styles.stockLabel}>
                  Stock: {stock}
                </SociollaText>
                <SociollaText style={styles.stockLabel}>
                  Out: {out}
                </SociollaText>
              </View>

              {tracker?.images?.length ? (
                <ScrollView
                  horizontal
                  showsHorizontalScrollIndicator={false}
                  style={{ marginTop: 14 }}>
                  {tracker.images.map((img, i) => (
                    <TouchableOpacity
                      key={i}
                      onPress={() => openImage(img)}
                      style={styles.photo}>
                      <Image
                        style={styles.photoImage}
                        width={90}
                        height={90}
                        source={img}
                        disableCDN={true}
                      />
                    </TouchableOpacity>
                  ))}
                </ScrollView>
              ) : null}
            </View>
          );
        })
      )}
    </ScrollView>
  );
};

GwpTrackerDisplay.propTypes = {
  gwpTrackers: PropTypes.array,
};

const styles = StyleSheet.create({
  container: {
    marginBottom: isWeb ? 30 : 0,
  },

  emptyState: {
    alignItems: 'center',
    marginTop: 60,
  },

  emptyTitle: {
    fontSize: 14,
    marginBottom: 6,
  },

  emptyDesc: {
    fontSize: 13,
    color: Colors.grey1,
  },

  card: {
    backgroundColor: Colors.white,
    padding: 20,
    borderRadius: 16,
    marginBottom: 16,
    borderWidth: 1,
    borderColor: Colors.grey0,
  },

  topRow: {
    flexDirection: 'row',
    marginBottom: 18,
  },

  campaign: {
    fontSize: 17,
    marginBottom: 6,
  },

  detail: {
    fontSize: 13,
    color: Colors.grey2,
  },

  brandBadge: {
    backgroundColor: Colors.blue0 + '15',
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 20,
    alignSelf: 'flex-start',
  },

  brandText: {
    fontSize: 12,
    color: Colors.blue0,
  },

  productRow: {
    flexDirection: 'row',
    marginBottom: 16,
  },

  productImage: {
    borderRadius: 16,
    marginRight: 14,
    backgroundColor: Colors.grey3,
  },

  productName: {
    fontSize: 14,
    marginBottom: 4,
  },

  productSku: {
    fontSize: 12,
    color: Colors.grey2,
  },

  progressBarBackground: {
    height: 6,
    backgroundColor: Colors.grey3,
    borderRadius: 10,
    overflow: 'hidden',
  },

  progressBarFill: {
    height: 6,
    backgroundColor: Colors.blue0,
  },

  stockRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },

  stockLabel: {
    fontSize: 13,
    color: Colors.textSecondary,
  },

  photo: {
    width: 80,
    height: 80,
    borderRadius: 16,
    overflow: 'hidden',
    marginRight: 12,
  },

  photoImage: {
    width: 80,
    height: 80,
  },
});

export default GwpTrackerDisplay;
